import React, { useState } from "react";

//UI Material
import {
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";

//Material Icons
import {
  ArrowForwardIos,
  Cancel,
  Error,
  RadioButtonChecked,
  RadioButtonUnchecked,
} from "@mui/icons-material";

//Helpers
import {
  checkIfPendingOrderIsDelayed,
  checkOrderStatus,
  generateChipForOrderStatus,
} from "../../Helpers/orderFunctions";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import ContainedButton from "../basics/ContainedButton";
import ModalWindow from "../Modal";

export default function OrderRow({ orders, getOrders }) {
  // ==========> Component States <==========
  //User data from localStorage
  const userData = JSON.parse(localStorage.getItem("userData"));
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");

  // ==========> Component Functions<==========

  //Function to prioritize an order
  const setPrioritize = async (orderNumber, priority) => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        "/orders/set-prioritize",
        {
          orderNumber,
          priority,
        }
      );
      const jsonReponse = await requestResponse.json();
      if (jsonReponse.status === "ok") {
        getOrders();
      } else {
        setModalText("No se pudo realizar la acción.");
        setModalDescription(jsonReponse.description);
        setModalOpen(true);
      }
    } catch (error) {
      setModalText("No se pudo realizar la acción.");
      setModalDescription(
        "Error al hacer los cambios, por favor verifica tu conexión a internet e inténtalo nuevamente."
      );
      setModalOpen(true);
    }
  };

  //Function to display prioritize icon
  const prioritizeIcon = (order) => {
    //Function to handle prioritize order
    const handlePrioritize = () => {
      setPrioritize(order.orderNumber, !order.priority);
    };
    const prioritizeOrder = handlePrioritize;

    if (order.canceledBy) {
      return <Cancel />;
    } else {
      return (
        <IconButton onClick={prioritizeOrder}>
          {order.priority ? (
            <RadioButtonChecked sx={{ color: "white" }} />
          ) : (
            <RadioButtonUnchecked />
          )}
        </IconButton>
      );
    }
  };

  // ==========> Component <==========
  return orders.map((order) => (
    <TableRow
      key={`${order.orderNumber}-${order.createdAt}`}
      sx={{
        backgroundColor: order.canceledBy
          ? "#B5B5B5"
          : order.priority && "#5CC7D2",
        animation: order.priority ? "blink-animation 5s infinite" : undefined,
      }}
    >
      <TableCell align="center">
        {userData.role === "ADMINISTRATOR" ? (
          <Stack direction="row" alignItems="center" justifyContent="center">
            {prioritizeIcon(order)}
            <Typography
              variant="body2"
              sx={{ color: order.priority && "white" }}
              fontWeight={order.priority && "bold"}
            >
              {order.orderNumber}
            </Typography>
          </Stack>
        ) : (
          <Typography
            variant="body2"
            sx={{ color: order.priority && "white" }}
            fontWeight={order.priority && "bold"}
          >
            {order.orderNumber}
          </Typography>
        )}
      </TableCell>
      <TableCell align="center">
        {order.billing.amount === 0 ? (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            justifyContent="center"
          >
            <Tooltip title="No se ha registrado la información de facturación para esta orden de producción.">
              <Error color="error" fontSize="12px" />
            </Tooltip>
            <Typography
              variant="body2"
              sx={{ color: order.priority && "white" }}
              fontWeight={order.priority && "bold"}
            >
              {order.client}
            </Typography>
          </Stack>
        ) : (
          <Typography
            variant="body2"
            sx={{ color: order.priority && "white" }}
            fontWeight={order.priority && "bold"}
          >
            {order.client}
          </Typography>
        )}
      </TableCell>
      <TableCell align="center">
        <Typography
          variant="body2"
          sx={{ color: order.priority && "white" }}
          fontWeight="bold"
        >
          {order.numberOfProducts}
        </Typography>
      </TableCell>
      <TableCell align="center">
        {order.billing.amount === 0 ? (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            justifyContent="center"
          >
            <Tooltip title="No se ha registrado la información de facturación para esta orden de producción.">
              <Error color="error" fontSize="12px" />
            </Tooltip>
            <Typography
              variant="body2"
              sx={{ color: order.priority && "white" }}
              fontWeight={order.priority && "bold"}
            >
              {order.productName}
            </Typography>
          </Stack>
        ) : (
          <Typography
            variant="body2"
            sx={{ color: order.priority && "white" }}
            fontWeight={order.priority && "bold"}
          >
            {order.productName}
          </Typography>
        )}
      </TableCell>
      <TableCell align="center">
        {generateChipForOrderStatus(
          checkOrderStatus(order.productsStatus, order.canceledBy)
        )}
      </TableCell>
      <TableCell align="center">
        <Typography
          variant="body2"
          sx={{ color: order.priority && "white" }}
          fontWeight={order.priority && "bold"}
        >
          {new Date(order.createdAt).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell align="center">
        {checkIfPendingOrderIsDelayed(order)}
      </TableCell>
      <TableCell align="center">
        <ContainedButton
          text="ABRIR"
          endIcon={<ArrowForwardIos />}
          onClick={() => {
            window.location.href = `/order?orderId=${order.orderNumber}`;
          }}
        />
      </TableCell>
      <ModalWindow
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        title={modalText}
        text={modalDescription}
        leftText="OK"
        leftClick={() => {
          setModalOpen(false);
        }}
      />
    </TableRow>
  ));
}
